export const GET_ADMIN_DASHBOARD_STICKY_COLUMNS = "GET_ADMIN_DASHBOARD_STICKY_COLUMNS";
export const GET_ADMIN_DASHBOARD_STICKY_COLUMNS_SUCCESS = "GET_ADMIN_DASHBOARD_STICKY_COLUMNS_SUCCESS";
export const GET_ADMIN_DASHBOARD_STICKY_COLUMNS_ERROR = "GET_ADMIN_DASHBOARD_STICKY_COLUMNS_ERROR";

export const UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS = "UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS";
export const UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS_SUCCESS = "UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS_SUCCESS";
export const UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS_ERROR = "UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS_SUCCESS";